/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Copy_Link_CopiedInputs */

const en_admin_resources_copy_link_copied = /** @type {(inputs: Admin_Resources_Copy_Link_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copied!`)
};

const de_admin_resources_copy_link_copied = /** @type {(inputs: Admin_Resources_Copy_Link_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiert!`)
};

const es_admin_resources_copy_link_copied = /** @type {(inputs: Admin_Resources_Copy_Link_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiado!`)
};

const fr_admin_resources_copy_link_copied = /** @type {(inputs: Admin_Resources_Copy_Link_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copié !`)
};

/** @type {(inputs: Admin_Resources_Copy_Link_CopiedInputs) => LocalizedString} */
const it_admin_resources_copy_link_copied = en_admin_resources_copy_link_copied;

/** @type {(inputs: Admin_Resources_Copy_Link_CopiedInputs) => LocalizedString} */
const pt_br2_admin_resources_copy_link_copied = en_admin_resources_copy_link_copied;

/** @type {(inputs: Admin_Resources_Copy_Link_CopiedInputs) => LocalizedString} */
const pl_admin_resources_copy_link_copied = en_admin_resources_copy_link_copied;

/** @type {(inputs: Admin_Resources_Copy_Link_CopiedInputs) => LocalizedString} */
const hu_admin_resources_copy_link_copied = en_admin_resources_copy_link_copied;

/** @type {(inputs: Admin_Resources_Copy_Link_CopiedInputs) => LocalizedString} */
const ro_admin_resources_copy_link_copied = en_admin_resources_copy_link_copied;

/**
* | output |
* | --- |
* | "Copied!" |
*
* @param {Admin_Resources_Copy_Link_CopiedInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_copy_link_copied = /** @type {((inputs?: Admin_Resources_Copy_Link_CopiedInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Copy_Link_CopiedInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_copy_link_copied(inputs)
	if (locale === "de") return de_admin_resources_copy_link_copied(inputs)
	if (locale === "es") return es_admin_resources_copy_link_copied(inputs)
	if (locale === "fr") return fr_admin_resources_copy_link_copied(inputs)
	if (locale === "it") return it_admin_resources_copy_link_copied(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_copy_link_copied(inputs)
	if (locale === "pl") return pl_admin_resources_copy_link_copied(inputs)
	if (locale === "hu") return hu_admin_resources_copy_link_copied(inputs)
	return ro_admin_resources_copy_link_copied(inputs)
});
export { admin_resources_copy_link_copied as "admin.resources.copy_link_copied" }